import { BMS_SHORT_NAME } from "../../../constant/assistanceProgram";
import { TEMPLATE_NAMES } from "../ApplicationFormEditor/templateNames";

/**
 * FIELD_VALUE_OVERRIDES
 *
 * This object defines static field-level overrides per templateName (vendor).
 * It's used to override or patch assistance program fields before any rendering/masking logic is applied.
 *
 * Use cases:
 * - Override values without changing the source-of-truth (AP DB)
 * - Enforcing template-specific adjustments (e.g., hiding a field by nullifying it)
 * - Providing values that don’t come from the backend but should always show in the UI
 *
 * Notes:
 * - Any field listed here will override the corresponding value from the original API response.
 * - Can be used in conjunction with FIELD_MASKING_CONFIG for full control.
 */

const regeneronCopayOverrides = {
  requiredDiagnosis: "aNSCLC, aBCC, aCSCC",
  assetId: "US.LIB.24.11.0054 02/25",
  APProvider: "Regeneron",
  displayName: "LIBTAYO Surround® Commercial Copay Program",
  drugDisplayName: "LIBTAYO",
  hideGrantTotal: true,
  possibleDrugs: [{ apDrugDisplayName: "LIBTAYO® (cemiplimab-rwlc)" }],
  lookbackRelevanceTime: "--",
  maxFpl: "--"
};

const regeneronPapOverrides = {
  requiredDiagnosis: "aNSCLC, aBCC, aCSCC",
  assetId: "US.LIB.24.11.0054 02/25",
  APProvider: "Regeneron",
  displayName: "LIBTAYO Surround® Patient Assistance Program",
  drugDisplayName: "LIBTAYO",
  hideGrantTotal: true,
  possibleDrugs: [{ apDrugDisplayName: "LIBTAYO® (cemiplimab-rwlc)" }],
  lookbackRelevanceTime: "--",
  maxFpl: "--"
};

const lillyOverrides = {
  hideGrantTotal: true
};

export const FIELD_VALUE_OVERRIDES = {
  [TEMPLATE_NAMES.REGENERON_COPAY]: regeneronCopayOverrides,
  [TEMPLATE_NAMES.REGENERON_PAP]: regeneronPapOverrides,
  [TEMPLATE_NAMES.BMS_COPAY]: {
    acceptedEnrolls: [],
    patientConsentRequired: null,
    APProvider: BMS_SHORT_NAME,
    hideValidThrough: true,
    hideGrantTotal: true
  },
  [TEMPLATE_NAMES.LILLY_COPAY]: lillyOverrides,
  [TEMPLATE_NAMES.LILLY_COPAY_SIGNATURE]: lillyOverrides
};

export const applyFieldOverrides = (templateName, original) => {
  const overrides = FIELD_VALUE_OVERRIDES[templateName] || {};
  return {
    ...original,
    ...overrides
  };
};
